export default __webpack_public_path__ + "static/babel-3dd6d0443e861a9a37ee9f33afeac0cb.svg";